import $ from 'jquery';

function CommonCtrl() {
	this.$pagetop = $('a[href^="#"]:not([href*="#menu"])');
	this.$inquiry = $('.form-wrapper');

	this.init();
}

CommonCtrl.prototype.init = function () {
	this.$pagetop.on('click', this.pagetop);
	this.inquiry();
}

CommonCtrl.prototype.pagetop = function (e) {
	e.preventDefault();

	var $self = $(this);
	var _href = $self.get(0).hash;
	var offset = $((_href === '' || _href === '#top') ? 'html' : _href).offset();

	var target = function() {
		if (typeof offset !== "undefined")
		{
			return offset;
		}

		return $('html').offset();
	};

	if (_href !== '')
	{
		$('html, body').stop().animate({
			scrollTop: target().top
		}, 500, 'swing');
	}

	if (_href !== '#top')
	{
		window.history.pushState(null, null, this.hash);
	}
}


CommonCtrl.prototype.inquiry = function () {
	const $form = this.$inquiry.find('form');
	$form.addClass('h-adr');
	$form.find('input[name="zip"]').on('focusout', function() {
		var zip = this.value;
		zip = zip.replace(/[^\d]/g, '');
		if (zip.length >= 3)
			zip = zip.substr(0, 3)+'-'+zip.substr(3);

		this.value = zip;
	});

	$form.find('.error').prev().addClass('error');
}

export default CommonCtrl;